
import { Vue, Component, Prop } from "vue-property-decorator";
import { Project, Project_Activity, User } from "@/generated/graphql";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import ContractorsMultiselect from "@/components/autocompleteMultiselects/ContractorsMultiselectNew.vue";
import ManagementActivityCard from "@/components/projects/activities/ManagementActivityCardNew.vue";
import TableHeaders from "@/views/manage/projectDetails/ActivityHeaders.vue";
import CardPagination from "@/components/card/PaginationNew.vue";
import EmptyListPlaceholder from "@/components/common/EmptyListPlaceholderNew.vue";
import ActivityCustomRequest from "@/components/projects/activities/ActivityCustomRequest.vue";
import FormGroup from "@/components/form/FormGroupNew.vue";
import GET_ACTIVITIES from "@/apollo/projectActivities/GetActivities.gql";
import InfoCircleFilled from "@/components/icons/InfoCircleFilled.vue";
@Component({
  components: {
    ContractorsMultiselect,
    ManagementActivityCard,
    TableHeaders,
    CardPagination,
    LoadingOverlay,
    EmptyListPlaceholder,
    ActivityCustomRequest,
    FormGroup,
    InfoCircleFilled
  },
  apollo: {
    activitiesDrafts: {
      query: GET_ACTIVITIES,
      variables() {
        return this.getActivitiesArgsDrafts;
      },
      update(data) {
        return data.project_activity;
      },
    },
  },
})
export default class DraftVisits extends Vue {
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  @Prop({ type: String, required: true }) readonly companyId!: string;

  contractorsIdsDrafts: string[] = [];
  activitiesDrafts: Project_Activity[] = [];
  paginationConfig = {
    page: 1,
    total: 0,
    limit: 8,
    loadedCount: 0,
  };
  get isLoading(): boolean {
    return this.$apollo.queries.activitiesDrafts.loading;
  }

get getActivitiesArgsDrafts() {
    const filterConditions = [];
    if (this.contractorsIdsDrafts.length > 0) {
      filterConditions.push({
        contractor: {
            id: {
              _in: this.contractorsIdsDrafts,
          },
        },
      });
    }
    return {
      where: {
        _and: [
          ...filterConditions,
          { project_id: { _eq: this.$route.params.id } },
          { deleted: { _eq: false } },
          { completed: { _eq: false } },
          { drafted: { _eq: true } },
        ],
      },
    };
  }

  // Check if activities are loaded
  get isActivitiesLoaded(): boolean {
    return this.isLoading && !!this.activitiesDrafts;
  }
  get isEmpty() {
    return !this.activitiesDrafts || this.activitiesDrafts.length === 0;
  }

  matchesSearch(activity, searchInput) {
    const assigneeId = activity.contractor?.user.id;
    return !searchInput.length || searchInput.includes(assigneeId);
  }

  updateContractorsFilter(selectedContractors) {
    this.contractorsIdsDrafts = selectedContractors;
  }

  handlePaginationEvent(newConfig) {
    this.paginationConfig = { ...newConfig };
  }

  onActivityListItemsChanged() {
    this.$emit("activityListChanged");
  }

  get isManager() {
    return this.currentUser.role === "Manager";
  }
}
